module.exports = __webpack_public_path__ + "img/join-banner.c85588b0.jpg";